import RestClient from '../services/RestClient'
import NetworkManager from '../services/NetworkManager'

const network = new NetworkManager(new RestClient(`${API_HOST}/api`))

export const readEndpoint = network.readEndpoint
export const createResource = network.createResource
export const updateResource = network.updateResource
export const deleteResource = network.deleteResource
